/**
 * Stable role key strings for code that intentionally references a specific role
 * (agency admin checks, platform-only guards, etc.).
 *
 * Inbound user-supplied keys are validated against the Firestore access catalog —
 * not against this list. See AccessCatalogService / validateAccessCatalog on backend.
 */
export const ROLE_KEYS = {
  AGENCY_ADMIN: 'agencyAdmin',
  PLATFORM_ADMIN: 'platformAdmin',
  CONTENT_MANAGER: 'contentManager',
  CONTENT_LIBRARY_USER: 'contentLibraryUser',
  TRANSFORM_USER: 'transformUser'
}

export function hasRoleKey(roleKeys = [], roleKey) {
  return Array.isArray(roleKeys) && roleKeys.includes(roleKey)
}

export function isAgencyAdminUser(user = {}) {
  return hasRoleKey(user.roleKeys, ROLE_KEYS.AGENCY_ADMIN)
}

export function accessLabelFromRoleKeys(roleKeys = []) {
  return isAgencyAdminUser({ roleKeys }) ? 'Admin Access' : 'General Access'
}

/** Maps Admin Center invite modal value to Firestore role keys for a new user. */
export function roleKeysForAccountPermission(accountPermission) {
  if (accountPermission === ROLE_KEYS.AGENCY_ADMIN) {
    return [ROLE_KEYS.AGENCY_ADMIN]
  }
  return []
}

/** Not assignable via Agency Admin Tool per-user editor. */
export const AGENCY_USER_ACCESS_FORBIDDEN_ROLE_KEYS = [
  ROLE_KEYS.PLATFORM_ADMIN,
  ROLE_KEYS.CONTENT_MANAGER
]
